"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var Backdrop = (0, styles_1.styled)(material_1.Backdrop)(function (_a) {
    var theme = _a.theme;
    return ({
        zIndex: theme.zIndex.tooltip + 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(Backdrop, {
    open: true,
});
